<template>
    <div class="favorite_button" @click="toggleFavorite" v-bind:class="{ favorited: my_favorite }">
        <svg class="default_icon favorite_icon"><use href="@/assets/icon_sprite.svg#favorite_dish_icon"/></svg>
        <span>{{ my_favorite ? 'Στα αγαπημένα' : 'Προσθήκη στα αγαπημένα' }}</span>

        <ActionModal v-if="show_login"
            title="Δεν έχετε συνδεθεί"
            description="Για να προσθέσεις την συνταγή στα αγαπημένα, πρέπει να συνδεθείς"
            action_btn="Σύνδεση"
            back_btn= "Ακύρωση"
            btn_type="action_btn"
            v-on:accept-action="gotoLogin"
            v-on:decline-action="show_login = false"
        />
    </div>
</template>

<script>

import { mapGetters } from "vuex";
import ActionModal from './Action_modal.vue';

export default {
    name: 'FavoriteButton',
    data() {
        return {
            my_favorite: false,
            show_login: false,
        }
    },
    props: [
        'recipe_id',
    ],
    components: {
        ActionModal,
    },
    computed: {
        ...mapGetters({
            user: "user"
        }),
    },
    watch: {
        "$store.getters.user.data": function () {
            if(this.user.data){
                this.showMyFavorite();
            }
        }
    },
    mounted(){
        if(this.user.data){
            this.showMyFavorite();
        }
    },
    methods: {
        toggleFavorite() {
            if (this.user.data) {
                fetch(process.env.VUE_APP_API+`/recipes/toggle_favorite`,{
                    method: "post",
                    headers: {
                        "TOKEN":JSON.stringify(this.user.data.token),
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "recipe_id": this.recipe_id
                    })
                }).then(res => res.json())
                .then(res => {
                    if(res.error){
                        this.errors = res.error
                    }
                    else {
                        this.my_favorite = res.my_favorite;
                    }
                });
            }
            else {
                this.show_login = true;
            }
        },
        showMyFavorite() {
            fetch(process.env.VUE_APP_API+`/recipes/my_favorite`,{
                method: "post",
                headers: {
                    "TOKEN":JSON.stringify(this.user.data.token),
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "recipe_id": this.recipe_id
                })
            }).then(res => res.json())
                .then(res => {
                    if(res.error){
                        this.errors = res.error;
                    }
                    else {
                        this.my_favorite = res.my_favorite;
                    }
            });
        },
        gotoLogin() {
            this.$router.push({ path: '/login?fwd=/recipes/'+this.recipe_id})
            this.show_login = false;
        }
    }
}
</script>

<style lang="scss" scoped>
.favorite_button {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  margin: 0.2rem;
  padding: 0.3rem 0.8rem;
  border-radius: 50px;
  transition: all 0.2s ease;
  cursor: pointer;
  svg {
      width: 1.3rem;
      height: 1.3rem;
      fill: var(--color-grey-2);
      transition: all 0.2s ease;
  }
  span {
      margin-left: 0.5rem;
  }
  &:hover {
    box-shadow: 0 2px 5px rgba(51, 51, 51, 0.25);
    svg {
        transform: scale(1.15);
        fill: var(--color-primary);
    }
  }
  &.favorited {
    svg {
      fill: var(--color-secondary);
    }
  }
}
</style>
